import { JSX } from 'react'

import { IconProps } from '../../icon'

const Drag: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M29.3922 12.7897C29.9602 13.3577 29.9602 14.2787 29.3922 14.8467C28.8242 15.4147 27.9032 15.4147 27.3352 14.8467L25.4546 12.9661V22.5455H35.0339L33.1533 20.6649C32.5853 20.0969 32.5853 19.1759 33.1533 18.6079C33.7213 18.0398 34.6424 18.0398 35.2104 18.6079L39.574 22.9715C40.142 23.5395 40.142 24.4605 39.574 25.0285L35.2104 29.3922C34.6424 29.9602 33.7213 29.9602 33.1533 29.3922C32.5853 28.8242 32.5853 27.9032 33.1533 27.3352L35.0339 25.4546H25.4546V35.0339L27.3352 33.1533C27.9032 32.5853 28.8242 32.5853 29.3922 33.1533C29.9602 33.7213 29.9602 34.6424 29.3922 35.2104L25.0285 39.574C24.4605 40.142 23.5395 40.142 22.9715 39.574L18.6079 35.2104C18.0398 34.6424 18.0398 33.7213 18.6079 33.1533C19.1759 32.5853 20.0969 32.5853 20.6649 33.1533L22.5455 35.0339V25.4546H12.9661L14.8467 27.3352C15.4147 27.9032 15.4147 28.8242 14.8467 29.3922C14.2787 29.9602 13.3577 29.9602 12.7897 29.3922L8.42602 25.0285C7.85799 24.4605 7.85799 23.5395 8.42602 22.9715L12.7897 18.6079C13.3577 18.0398 14.2787 18.0398 14.8467 18.6079C15.4147 19.1759 15.4147 20.0969 14.8467 20.6649L12.9661 22.5455H22.5455V12.9661L20.6649 14.8467C20.0969 15.4147 19.1759 15.4147 18.6079 14.8467C18.0398 14.2787 18.0398 13.3577 18.6079 12.7897L22.9715 8.42602C23.5395 7.85799 24.4605 7.85799 25.0285 8.42602L29.3922 12.7897Z'
      fill='black'
    />
  </svg>
)

export default Drag
